export const deliveryLeadTimeValues = [
    {
        value: "1",
        label: "1 week",
    },
    {
        value: "2",
        label: "2 weeks",
    },
    {
        value: "3",
        label: "3 weeks",
    },
    {
        value: "4",
        label: "4 weeks",
    },
    {
        value: "0",
        label: "Others",
    },
];